import { render, staticRenderFns } from "./ShowContent.vue?vue&type=template&id=15dd6090&scoped=true"
import script from "./ShowContent.vue?vue&type=script&lang=js"
export * from "./ShowContent.vue?vue&type=script&lang=js"
import style0 from "./ShowContent.vue?vue&type=style&index=0&id=15dd6090&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15dd6090",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/ap/jenkins/workspace/prod-ykd360-admin-front(医可达旧管理端)/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15dd6090')) {
      api.createRecord('15dd6090', component.options)
    } else {
      api.reload('15dd6090', component.options)
    }
    module.hot.accept("./ShowContent.vue?vue&type=template&id=15dd6090&scoped=true", function () {
      api.rerender('15dd6090', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/subgroup/ShowContent.vue"
export default component.exports